import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-961bd642"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_header_main" }
const _hoisted_2 = { class: "home_logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "header_main_nav_ul",
  style: {"margin-left":"15px"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "header_main_nav_ul" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "header_account_wrap" }
const _hoisted_9 = { class: "tips-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "温馨提示：点击此处可切换至客管后台V1.0", -1))
const _hoisted_11 = { class: "header_dropdown" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "modal_msg_wrap" }
const _hoisted_15 = ["innerHTML"]

import { computed, reactive, defineAsyncComponent, ref, onUnmounted } from 'vue';
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { useStore } from 'vuex';
import { Layout, Dropdown, Menu, Popover, Badge, Modal } from 'ant-design-vue';
import { SwapOutlined, InfoCircleFilled } from '@ant-design/icons-vue';
import http from '@/api/home';
import { removeToken, getCertificationView } from '@/plugins/cookie';
import { fontFormat } from '@/utils/format';
import { MsgClass, RootMsg } from '@/store/modules/home/type';
import { RootModal } from '@/types/base';
import { LiveInfo } from '@/store/modules/live/types';
import AppLink from '@/components/AppLink.vue';
import EventBus from '@/components/EventBus';
import { useHomeStore } from '@/pinia/home';
import SvgIcon from '@/components/SvgIcon.vue'; // svg component
import { useLiveStore } from '@/pinia/live';

interface IProps {
  isCollapsed: boolean;
  sourceData: RouteRecordRaw[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    isCollapsed: { type: Boolean },
    sourceData: null
  },
  emits: ['switch'],
  setup(__props: any, { emit }) {

const props = __props as {
  isCollapsed: boolean;
  sourceData: RouteRecordRaw[];
};

const TabPane = defineAsyncComponent(() => import('./TabPane.vue'));
const store = useStore();
const userData = computed(() => store.state.user.userInfo);
const menu = computed(() => store.state.home.menu);

const homeStore = useHomeStore();
// const oldVersion = computed(() => homeStore.funcData?.oldVersion); //  旧版本切换按钮显示

const aLayoutHeader = Layout.Header;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const aDropdown = Dropdown;
const aPopover = Popover;
// const aTabs = Tabs;
// const aTabPane = Tabs.TabPane;
const aBadge = Badge;
const aModal = Modal;

const router = useRouter();



const customLayoutStyle = computed(() => store.state.home.customLayoutStyle);
// const liveInfo = computed(() => unref(inject('liveInfo')) as LiveInfo);

const getStudioId = (liveInfo: LiveInfo): number => {
  let id = 0;
  if (!liveInfo) {
    id = 0;
  } else if (liveInfo.stream_list && liveInfo.mode === 4) {
    id = liveInfo.stream_list[0].id;
  } else if (liveInfo.studio_language && liveInfo.mode === 5) {
    id = liveInfo.studio_language[0].id;
  } else {
    id = liveInfo.id;
  }
  return id;
};

const liveStore = useLiveStore();
const isLanguageStudio = computed(() => liveStore.liveInfo.mode === 5 && liveStore.liveInfo.id === liveStore.liveInfo.studio_pid);
const isStreamStudio = computed(() => liveStore.liveInfo.mode === 4 && liveStore.liveInfo.id === liveStore.liveInfo.studio_pid);
// const consoleMenu = ref<
//   {
//     path: string;
//     name: string;
//     title: string;
//     icon: string;
//   }[]
// >([]);
const consoleMenu = computed(() =>
  [
    {
      path: `/live_set/${route.params.studioId}/broad_cast_control`,
      name: 'BroadCastControl',
      title: '基础设置',
      icon: 'settings',
      routeParent: 'liveSet',
      visibel: true,
    },
    {
      path: `/pages_editor/${route.params.studioId}/page_director`,
      name: 'PageDirector',
      title: '页面配置',
      icon: 'browser',
      routeParent: 'PagesEditor',
      visibel: !isLanguageStudio.value,
    },
    {
      path: `/market/${route.params.studioId}/${isLanguageStudio.value ? 'red_envelope_rain' : 'mutually_engage'}`,
      name: `${isLanguageStudio.value ? 'MutuallyEngage' : 'MutuallyEngage'}`,
      title: '营销互动',
      icon: 'menu_present',
      routeParent: 'Market',
      visibel: true,
    },
    {
      path: `/view_warrent/${route.params.studioId}/authorization`,
      name: 'Authorization',
      title: '观看授权',
      icon: 'warrent_view',
      routeParent: 'viewWarrent',
      visibel: true,
    },
    {
      path: `/playback/${route.params.studioId}/playback_settings`,
      name: 'playBack',
      title: '视频回放',
      icon: 'menu_playblack',
      routeParent: 'PlayBack',
      visibel: !isStreamStudio.value && !isLanguageStudio.value,
    },
    {
      path: `/data_center/${route.params.studioId}/${homeStore.funcData['LiveData'] ? 'live' : 'questionnaire'}`,
      name: 'LiveData',
      title: '数据统计',
      icon: 'browser',
      routeParent: 'DataCenter',
      visibel: !isStreamStudio.value,
    },
    {
      path: `/console/${route.params.studioId}`,
      name: 'Console',
      title: '发起直播',
      icon: 'settings',
      visibel: true,
    },
  ].filter((e) => e.visibel === true)
);

// const HomeLogo = computed(() => store.state.home.customData.top_logo_url);
const ConsoleLogo = computed(() =>
  store.state.home.customStatus && store.state.home.customData.top_logo_url !== process.env.VUE_APP_OTHER_LINK+'/top_logo.svg'
    ? store.state.home.customData.top_logo_url
    : store.state.home.black_top_logo_url
);

const route = useRoute();
const openKeys = ref((route.meta.routeParent as string) ?? 'Home');
const header = {
  path: '/',
  name: 'Home',
  meta: {
    title: '平台概览',
    icon: 'DesktopOutlined',
  },
};

// const pathStatus = ref(0);
// const path = ref(['/home', '/live', '/media', '/account_info', '/upload-userInfo']);
// const routeChange = (to: any) => {
//   switch (true) {
//     case to.fullPath.includes('/home'):
//       pathStatus.value = 0;
//       break;
//     case to.fullPath.includes('/live'):
//       pathStatus.value = 1;
//       break;
//     case to.fullPath.includes('/media'):
//       pathStatus.value = 2;
//       break;
//     case to.fullPath.includes('/wallet'):
//       pathStatus.value = 3;
//       break;
//     default:
//       pathStatus.value = 4;
//       break;
//   }
// };
onBeforeRouteUpdate((to) => {
  // routerWatch(to.meta.routeParent as string);
  openKeys.value = (to.meta?.routeParent as string) ?? 'Home';

  // routeChange(to);
});

// routeChange(route);

const onTabChange = (name: any): void => {
  openKeys.value = name;
};

const onCollapsedTrigger = () => {
  emit('switch');
};

// start message
const searchData = new MsgClass({
  page: 1,
  page_num: 5,
  status: 1,
  type: 0,
});
const msgData = ref<RootMsg[]>([]);
const getMsgList = async () => {
  const res = await http.getAllMsg({
    params: searchData,
  });
  const resData = res.data.data.data;
  msgData.value = resData.map((v: RootMsg) => {
    v.title = v.message.replace(/<\/?.+?>/g, '').replace('&nbsp;', '');
    return v;
  });
  if (msgData.value.length > 0) {
    if (!msgInfo.value) {
      msgInfo.value = msgData.value.shift();
      infoModal.visible = true;
      http.getAllMsgInfo({
        params: {
          id: msgInfo.value?.id,
        },
      });
    }
    // msgVisible.value = true;
  }
};
getMsgList();

const msgVisible = ref(false);
const onMsgTrigger = async () => {
  msgVisible.value = false;
};
const msgInfo = ref<RootMsg>();
const infoModal = reactive<Required<RootModal>>({
  title: '消息中心',
  visible: false,
  loading: false,
  centered: true,
  width: 500,
});
const onCanceInforModal = async () => {
  // const res = await http.getAllMsg({
  //   params: searchData,
  // });
  // const resData = res.data.data.data;
  // msgData.value = resData.map((v: RootMsg) => {
  //   v.title = v.message.replace(/<\/?.+?>/g, '').replace('&nbsp;', '');
  //   return v;
  // });
};
const openModal = async (index: number) => {
  msgInfo.value = msgData.value[index];
  infoModal.title = msgData.value[index].type_name;
  infoModal.visible = !infoModal.visible;
  infoModal.width = document.body.clientWidth / 2;
  await http.getAllMsgInfo({
    params: {
      id: msgData.value[index].id,
    },
  });
  getMsgList();
};

// 接收消息
const getBroadCast = () => {
  getMsgList();
  // msgVisible.value = true;
};
EventBus.on('broadcast', getBroadCast);
EventBus.on('updateMsgList', getMsgList);

onUnmounted(() => {
  EventBus.off('broadcast', getBroadCast);
  EventBus.off('updateMsgList', getMsgList);
});

// end message
const onExit = () => {
  removeCache();
  router.removeRoute('Layout');
  const sub = localStorage.getItem('subState');
  if (!sub) {
    router.replace('Login');
    // location.reload();
  } else {
    const subAlias = localStorage.getItem('sub_logo');
    router.push(`/${subAlias}/sub_login`);
    localStorage.removeItem('subState');
  }
};
const removeCache = () => {
  localStorage.removeItem('subToken');
  localStorage.removeItem('cache_tokens');
  localStorage.removeItem('lighostoken');
  localStorage.removeItem('certification_status');
  localStorage.removeItem('helper');
  localStorage.removeItem('ETLCD');
  localStorage.removeItem('examine');
  localStorage.removeItem('auyst');
  localStorage.removeItem('syfhs');
  localStorage.removeItem('alias');
  sessionStorage.removeItem('display_logo');
  sessionStorage.removeItem('loginVersionName');
  sessionStorage.removeItem('func');
  sessionStorage.removeItem('roleStatus');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_unref(aLayoutHeader), { class: "home_header_wrap" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", {
            class: "home_header_toggle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onCollapsedTrigger()))
          }, [
            _withDirectives(_createVNode(SvgIcon, {
              class: "trigger",
              "icon-class": "MenuUnfoldOutlined"
            }, null, 512), [
              [_vShow, props.isCollapsed]
            ]),
            _withDirectives(_createVNode(SvgIcon, {
              class: "trigger",
              "icon-class": "MenuFoldOutlined"
            }, null, 512), [
              [_vShow, !props.isCollapsed]
            ])
          ], 512), [
            [_vShow, !_unref(customLayoutStyle)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("img", {
                  src: _unref(ConsoleLogo),
                  alt: ""
                }, null, 8, _hoisted_3), [
                  [_vShow, _unref(ConsoleLogo)]
                ])
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(customLayoutStyle)]
            ])
          ], 512), [
            [_vShow, _unref(customLayoutStyle)]
          ]),
          _withDirectives(_createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(consoleMenu), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.path,
                class: "header_nav_li",
                onClick: ($event: any) => (onTabChange(item.name))
              }, [
                _createVNode(AppLink, {
                  class: _normalizeClass(["link", item.name === openKeys.value ? 'on' : '']),
                  to: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"])
              ], 8, _hoisted_5))
            }), 128))
          ], 512), [
            [_vShow, _unref(customLayoutStyle)]
          ]),
          _withDirectives(_createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", {
              class: "header_nav_li",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onTabChange(header.name)))
            }, [
              _createVNode(_component_router_link, {
                class: _normalizeClass(["link", header.name === openKeys.value ? 'on' : '']),
                to: header.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(header.meta?.title), 1)
                ]),
                _: 1
              }, 8, ["class", "to"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.path,
                class: "header_nav_li",
                onClick: ($event: any) => (onTabChange(item.name))
              }, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["link", item.name === openKeys.value ? 'on' : '']),
                  to: item.name === 'Wallet' && item.children ? item.children[0].path : item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.meta?.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"])
              ], 8, _hoisted_7))
            }), 128))
          ], 512), [
            [_vShow, !_unref(customLayoutStyle)]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(aPopover), {
            placement: "bottom",
            trigger: "hover"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(InfoCircleFilled), { class: "tips" }),
                _hoisted_10
              ])
            ]),
            _: 1
          }),
          (_unref(homeStore).funcData?.MessageCenter)
            ? (_openBlock(), _createBlock(_unref(aPopover), {
                key: 0,
                visible: msgVisible.value,
                "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((msgVisible).value = $event)),
                "get-popup-container": (triggerNode) => triggerNode.parentNode,
                "overlay-class-name": "msg_menu_wrap",
                trigger: "click",
                placement: "bottomRight"
              }, {
                content: _withCtx(() => [
                  _createVNode(_unref(TabPane), {
                    resource: msgData.value,
                    onCloseMenu: onMsgTrigger,
                    onGetInfo: openModal
                  }, null, 8, ["resource"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    class: "header_account_btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aBadge), {
                        dot: true,
                        count: msgData.value.length
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            class: "header_icon",
                            "icon-class": "message"
                          })
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible", "get-popup-container"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(aDropdown), {
              "get-popup-container": (triggerNode) => triggerNode.parentNode,
              "overlay-class-name": "overlay_dropdown",
              trigger: ['click']
            }, {
              overlay: _withCtx(() => [
                _createVNode(_unref(aMenu), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sourceData, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.path
                      }, [
                        (item.path !== '/site')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: item.path
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_unref(aMenuItem), {
                                  key: item.path
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.meta?.title), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("a", null, [
                      _createVNode(_unref(aMenuItem), {
                        key: "exit",
                        onClick: onExit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 安全退出 ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "header_dropdown_avatar",
                    src: _unref(userData).avatar
                  }, null, 8, _hoisted_12),
                  _createElementVNode("a", {
                    class: "header_dropdown_link ant-dropdown-link",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(fontFormat)(_unref(userData).name)), 1),
                    _createVNode(SvgIcon, {
                      class: "dropdown_icon",
                      "icon-class": "caret_down_outlined"
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["get-popup-container"])
          ])
        ])
      ]),
      _createVNode(_unref(aModal), {
        visible: infoModal.visible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((infoModal.visible) = $event)),
        centered: infoModal.centered,
        footer: null,
        title: infoModal.title,
        width: 800,
        onCancel: onCanceInforModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              innerHTML: msgInfo.value?.message
            }, null, 8, _hoisted_15)
          ])
        ]),
        _: 1
      }, 8, ["visible", "centered", "title"])
    ]),
    _: 1
  }))
}
}

})